<template>
	<div class="login-box">
		<div class="login-wrap">
			<div class="login-nav">
				<dl :class="type==1?'active':''" @click="toRouter(1)">
					<dt>
						<i class="el-icon-monitor"></i>
					</dt>
					<dd>登录</dd>
				</dl>
				<dl :class="type==2?'active':''" @click="toRouter(2)">
					<dt>
						<i class="el-icon-mouse"></i>
					</dt>
					<dd>注册</dd>
				</dl>
				<dl @click="toHome">
					<dt>
						<i class="el-icon-price-tag"></i>
					</dt>
					<dd>首页</dd>
				</dl>
			</div>
			<div class="login-cont" v-if="type==1" v-loading="loading" element-loading-text="拼命登录中">
				<div class="login-title">
					登录
				</div>
				<div class="login-item">
					<input v-model.trim="luser" type="text" placeholder="用户账号" />
				</div>
				<div class="login-item">
					<input v-model.trim="lpwd" type="password" placeholder="登录密码" />
				</div>
				<div class="login-btn" @click="login">
					立即登录
				</div>
			</div>
			<div class="login-cont" v-if="type==2" v-loading="loading2" element-loading-text="拼命注册中">
				<div class="login-title">
					注册
				</div>
				<div class="login-item">
					<input v-model.trim="user" type="text" placeholder="请输入注册账号" />
				</div>
				<div class="login-item">
					<input v-model.trim="pwd" type="password" placeholder="请输入登录密码" />
				</div>
				<div class="login-item">
					<input v-model.trim="pwd2" type="password" placeholder="再次输入登录密码" />
				</div>
				<div class="login-txt">登录或注册即表示同意<span>服务协议</span>与<span>隐私政策</span></div>
				<div class="login-btn" @click="register">
					立即注册
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/api/api'
	export default{
		data(){
			return{
				type:1,
				luser:'',
				lpwd:'',
				user:'',
				pwd:'',
				pwd2:'',
				loading:false,
				loading2:false
			}
		},
		methods:{
			login(){
				if(this.luser == ''){
					this.$message.error('请输入账号');
					return
				}
				if(this.lpwd == ''){
					this.$message.error('请输入密码');
					return
				}
				let params = {
					user:this.luser,
					pwd:this.lpwd
				}
				this.loading = true;
				api.login(params).then(res=>{
					this.loading = false;
					if(res.code==200){
						this.$message.success('登录成功');
						api.setCookie('token', res.data.token,30);
						this.$router.push('/member');
					}else{
						this.$message.error(res.msg);
					}
					console.log(res)
				})
			},
			register(){
				if(this.user == ''){
					this.$message.error('请输入注册账号');
					return
				}else{
					const reg = /^[A-Za-z0-9]+$/;
					let rest = reg.test(this.user);
					if(rest){
						let len = this.user.length;
						if(len>=4 && len<=12){
							
						}else{
							this.$message.error('注册账号长度在4-10之间');
							return
						}
					}else{
						this.$message.error('注册账号只能是数字或英文字母');
						return
					}
				}
				if(this.pwd==''){
					this.$message.error('请输入登录密码');
					return
				}else{
					let len = this.pwd.length;
					if(len<6){
						this.$message.error('登录密码过于简单');
						return
					}
				}
				if(this.pwd2==''){
					this.$message.error('请确认登录密码');
					return
				}else{
					if(this.pwd != this.pwd2){
						this.$message.error('两次输入的密码不一致');
						return
					}
				}
				let params = {
					user: this.user,
					pwd: this.pwd
				}
				this.loading2 = true;
				api.register(params).then(res=>{
					this.loading2 = false;
					if(res.code==200){
						this.$message.success('注册成功');
						api.setCookie('token', res.data.token,30);
						this.$router.push('/member');
					}else{
						this.$message.error(res.msg);
					}
				})
			},
			toRouter(data){
				this.type = data;
			},
			toHome(){
				location.href = "http://www.beiyv.com"
			}
		},
		mounted() {
			let type = this.$route.query.type;
			if(type==2){
				this.type = 2;
			}
		}
	}
</script>

<style>
	.login-txt{
		font-size: 12px;
		text-align: right;
		padding-top: 10px;
		color: #999;
	}
	.login-txt span{
		padding: 0 5px;
		color: var(--color);
	}
	.login-btn {
		background-color: var(--color);
		height: 46px;
		line-height: 46px;
		width: 100%;
		border-radius: 10px;
		box-sizing: border-box;
		font-size: 14px;
		text-align: center;
		color: #fff;
		margin-top: 50px;
		cursor: pointer;
	}

	.login-btn:hover {
		background-color: var(--color2);
	}

	.login-cont {
		padding: 40px 50px 40px 70px;
		border-left: 1px solid #eee;
	}

	.login-item {
		padding-top: 20px;
	}

	.login-item input {
		background-color: #fff;
		height: 46px;
		border: 0;
		outline: none;
		width: 100%;
		border-radius: 10px;
		box-sizing: border-box;
		font-size: 14px;
		padding: 0 20px;
		border: 1px solid #fff;
		transition: all .3s;
	}
	
	.login-item input:hover,.login-item input:focus {
		border-color: var(--color);
	}

	.login-title {
		font-size: 21px;
		letter-spacing: 10px;
		text-indent: 5px;
		text-align: center;
		padding-bottom: 10px;
	}

	.login-cont {
		flex: 1;
		margin-left: 20px;
	}

	.login-nav .active dt,.login-nav dl:hover dt{
		background-color: var(--color);
		color: #fff;
	}

	.login-nav .active dd {
		color: var(--color);
	}

	.login-nav dl {
		margin: 0;
		color: #666;
	}

	.login-nav dl dt {
		width: 45px;
		height: 45px;
		text-align: center;
		line-height: 45px;
		background-color: #fff;
		border-radius: 30%;
		font-size: 20px;
		margin: 0 auto;
	}

	.login-nav dl dd {
		font-size: 14px;
		margin: 0;
		text-align: center;
		padding-top: 10px;
		margin-bottom: 40px;
	}

	.login-nav {
		width: 100px;
		height: 100%;
		padding-top: 20px;
		box-sizing: border-box;
	}

	.login-wrap {
		display: flex;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-top: -200px;
		margin-left: -350px;
		width: 700px;
		background-color: rgba(255,255,255,.8);
		border-radius: 10px;
		padding: 30px;
		box-sizing: border-box;
	}

	.login-box {
		width: 100%;
		height: 100vh;
		background-color: #222;
		background-image: url('http://www.beiyv.com/upload/bg/bg3.jpg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>



// WEBPACK FOOTER //
// src/page/login.vue